module.exports = __webpack_public_path__ + "logo_fundacion-15057c78cefb08ba331c024ced691a03.jpg";